<template>
    <div class="w-full my-3 min-h-48">
        <Carousel v-if="!contents" :items-to-show="3" :breakpoints="breakpoints" :wrapAround="true" :transition="500">
            <Slide v-for="placeholder in placeholders" :key="placeholder.id">
                <SlidePlaceholder class="w-full m-3" />
            </Slide>
        </Carousel>
        <Carousel v-else :items-to-show="3" :breakpoints="breakpoints" :wrapAround="true" :transition="500">
            <Slide v-for="feature in contents" :key="feature.id">
                <Link :href="'/song/' + feature.id" class="w-full m-3 block">
                <div class="w-full p-4 rounded-lg  hover:shadow-md transition-all duration-300"
                    :style='{ backgroundColor: backgroundFromBlurhash(feature.blur_hash) }'>
                    <div class="rounded-lg overflow-hidden mb-3">
                        <img :src="feature.cover" loading="lazy" class="w-full object-cover h-48" :alt="feature.name" />
                    </div>
                    <h2 class="text-lg font-semibold text-white truncate">{{ feature.name }}</h2>
                    <h3 class="text-md font-light text-nomad-200 mt-1 truncate">
                        {{ feature.artist.name }}
                    </h3>
                </div>
                </Link>
            </Slide>
        </Carousel>
    </div>
</template>
<script>
import { Carousel, Slide, Pagination, Navigation } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";
import { Link } from "@inertiajs/vue3";
import { SlidePlaceholder } from "@/components/placeholders/placeholder.js";
import { getBlurHashAverageColor } from 'fast-blurhash';
export default {
    props: {
        contents: Array,
    },
    data() {
        return {
            placeholders: [{ id: 1 }, { id: 2 }, { id: 3 }, { id: 4 }],
            // breakpoints are mobile first
            // any settings not specified will fallback to the carousel settings
            breakpoints: {
                // 700px and up
                100: {
                    itemsToShow: 1.2,
                    snapAlign: "center",
                },
                700: {
                    itemsToShow: 2.2,
                    snapAlign: "center",
                },
                // 1024 and up
                1024: {
                    itemsToShow: 3,
                    snapAlign: "start",
                },
            },
        };
    },
    components: {
        Carousel,
        Slide,
        Pagination,
        Navigation,
        Link,
        SlidePlaceholder,
    },
    methods: {
        backgroundFromBlurhash(blurhash) {
            if (!blurhash) {
                return '#494C43'; // default background color
            }

            const rgbAverageColor = getBlurHashAverageColor(blurhash);
            return `rgba(${rgbAverageColor.join(',')}, 0.3)`; // adding some transparency

        },
    }
};
</script>
<style scoped>
.carousel__pagination-button.carousel__pagination-button--active:after {
    border-radius: 0.25rem;
    background-color: #888C7D;
}

.carousel__pagination-button:after {
    border-radius: 0.25rem;
    background-color: #494C43;
}
</style>
